module.exports = __webpack_public_path__ + "img/grey_039.df337bac.png";